// ============================================
// App Constants
// ============================================
export * from './indonesian-cities';
export const APP_NAME = 'BID LMS V3';
export const APP_VERSION = '1.0.0';
export const APP_LOGO_URL = 'https://web-admin-lms-v3.netlify.app/logo.png';
// ============================================
// Participant Support
// ============================================
/** Single official WhatsApp destination for help and technical issues. */
export const BID_SUPPORT_WHATSAPP_URL = 'https://wa.me/6285171713300';
export const BID_SUPPORT_WHATSAPP_DISPLAY = '+62 851-7171-3300';
export const BID_SUPPORT_WHATSAPP_LABEL = 'BID Support';
// ============================================
// Participant background
// ============================================
/**
 * Canonical occupation values stored in `User.legacyMetadata`. Labels belong
 * to each portal's localized copy, so an Arabic UI never has to translate
 * historical Indonesian strings saved by an earlier registration.
 */
export const PARTICIPANT_OCCUPATIONS = [
    'STUDENT',
    'TEACHER',
    'PRIVATE_EMPLOYEE',
    'CIVIL_SERVANT',
    'ENTREPRENEUR',
    'HOMEMAKER',
    'HEALTHCARE_PROFESSIONAL',
    'NOT_CURRENTLY_WORKING',
    'OTHER',
];
/** Canonical highest-education values stored alongside participant profiles. */
export const PARTICIPANT_EDUCATION_LEVELS = [
    'NO_FORMAL_EDUCATION',
    'PRIMARY',
    'JUNIOR_SECONDARY',
    'SENIOR_SECONDARY',
    'DIPLOMA',
    'BACHELOR',
    'MASTER',
    'DOCTORAL',
    'OTHER',
];
// ============================================
// Pagination
// ============================================
export const DEFAULT_PAGE = 1;
export const DEFAULT_LIMIT = 20;
export const MAX_LIMIT = 100;
// ============================================
// Roles
// ============================================
export const ROLES = {
    SUPER_ADMIN: 'super_admin',
    ADMIN: 'admin',
    INSTRUCTOR: 'instructor',
    PARTICIPANT: 'participant',
};
// ============================================
// Program Status
// ============================================
export const PROGRAM_STATUS = {
    DRAFT: 'DRAFT',
    PUBLISHED: 'PUBLISHED',
    ARCHIVED: 'ARCHIVED',
};
// ============================================
// Registration Status
// ============================================
export const REGISTRATION_STATUS = {
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    CANCELLED: 'CANCELLED',
};
// ============================================
// Enrollment Status
// ============================================
export const ENROLLMENT_STATUS = {
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
    COMPLETED: 'COMPLETED',
    DROPPED: 'DROPPED',
};
// ============================================
// Material Types
// ============================================
export const MATERIAL_TYPES = {
    VIDEO: 'VIDEO',
    DOCUMENT: 'DOCUMENT',
    QUIZ: 'QUIZ',
    REFLECTION: 'REFLECTION',
    DISCUSSION: 'DISCUSSION',
};
// ============================================
// Evaluation Types
// ============================================
export const EVALUATION_TYPES = {
    QUIZ: 'QUIZ',
    EXAM: 'EXAM',
    SURVEY: 'SURVEY',
};
// ============================================
// Question Types
// ============================================
export const QUESTION_TYPES = {
    MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
    TRUE_FALSE: 'TRUE_FALSE',
    SHORT_ANSWER: 'SHORT_ANSWER',
    ESSAY: 'ESSAY',
};
// ============================================
// Storage Keys
// ============================================
export const STORAGE_KEYS = {
    AUTH_TOKEN: 'lms_auth_token',
    REFRESH_TOKEN: 'lms_refresh_token',
    USER: 'lms_user',
    THEME: 'lms_theme',
    LANGUAGE: 'lms_language',
};
// ============================================
// Validation Limits
// ============================================
export const VALIDATION = {
    MIN_PASSWORD_LENGTH: 8,
    MAX_PASSWORD_LENGTH: 128,
    MIN_NAME_LENGTH: 2,
    MAX_NAME_LENGTH: 100,
    MAX_DESCRIPTION_LENGTH: 5000,
    MAX_TEXT_ANSWER_LENGTH: 10000,
};
